import api from '../utils/request';

export const classicQuestionsApi = {
  listQuestions: async (params = {}) => {
    const response = await api.get('/classic-questions/', { params });
    return response.data;
  },

  getQuestion: async (id) => {
    const response = await api.get(`/classic-questions/${id}`);
    return response.data;
  },

  incrementView: async (id) => {
    const response = await api.post(`/classic-questions/${id}/view`);
    return response.data;
  }
};

export default classicQuestionsApi;
